import * as React from "react";

function ChevronLeftLarge(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4849 12L8 5.29936L9.25754 4L17 12L9.25754 20L8 18.7006L14.4849 12Z"
        fill="white"
      />
    </svg>
  );
}

export default ChevronLeftLarge;
